import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TelemetryUserContext {
    #userIds: string[] = [];

    setAuthenticatedUser(userId: string | undefined): void {
        if (userId) this.#userIds.push(userId);
    }

    setImpersonator(impersonatorId: string | undefined): void {
        if (impersonatorId) this.#userIds.push(impersonatorId);
    }

    getUserIds(): string[] {
        return this.#userIds;
    }
}
